module.exports = __webpack_public_path__ + "img/054.d1450981.png";